export default __webpack_public_path__ + "static/robotomono-regular-0ff7daca31863f66d72b77abfa2de0e9.woff";